import { createTheme } from '@mui/material/styles';

import { getPlatform } from './config';

const wixTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f0f4f7',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '18px',
        },
        contained: {
          backgroundColor: '#3899ec',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {},
        filledInfo: {
          border: '1px solid #afafaf',
          backgroundColor: 'inherit',
          color: '#0b1f35',
        },
        filledSuccess: {
          border: '1px solid #13a454',
          backgroundColor: '#ebf9f1',
          color: '#0b1f35',
        },
        filledError: {
          border: '1px solid #d91d0b',
          color: '#d91d0b',
          backgroundColor: '#feebea',
        },
      },
    },
  },
});

const standaloneTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f0f4f7',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '12px',
        },
        contained: {
          // backgroundColor: '#121212',
          // ':hover': {
          //   backgroundColor: '#333',
          // },
        },
        outlined: {
          // color: '#37352f',
          // borderColor: '#37352f29',
          // ':hover': {
          //   backgroundColor: '#e1e1e1',
          //   borderColor: '#37352f29',
          // },
        },
        text: {
          // color: '#37352f',
          // ':hover': {
          //   backgroundColor: '#e1e1e1',
          // },
        }
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {},
        filledInfo: {
          border: '1px solid #afafaf',
          backgroundColor: 'inherit',
          color: '#0b1f35',
        },
        filledSuccess: {
          border: '1px solid #13a454',
          backgroundColor: '#ebf9f1',
          color: '#0b1f35',
        },
        filledError: {
          border: '1px solid #d91d0b',
          color: '#d91d0b',
          backgroundColor: '#feebea',
        },
      },
    },
  },
});

export const theme = getPlatform() === 'wix' ? wixTheme : standaloneTheme;
